import {Link} from "react-router";
import {usePageTitle} from "../components/usePageTitle";
import {useNotFoundMeta} from "../components/usePageMeta";
import {common} from "../i18n";

export function NotFoundPage() {
    usePageTitle(common.notFound.title);
    useNotFoundMeta();
    return (
        <div className="text-center py-5">
            <h1 className="display-6">{common.notFound.title}</h1>
            <p className="text-body-secondary">{common.notFound.text}</p>
            <Link to="/">{common.notFound.home}</Link>
        </div>
    );
}
